import { render, staticRenderFns } from "./OtherPropertyInsurance.vue?vue&type=template&id=775bed10"
import script from "./OtherPropertyInsurance.vue?vue&type=script&lang=js"
export * from "./OtherPropertyInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports